package net.maraclinic.app.theme

import org.jetbrains.compose.web.css.*

object Dimensions {

    val ExtraTiny = 0.8.cssRem
    val Tiny = 1.6.cssRem
    val ExtraSmall = 2.4.cssRem
    val Small = 3.2.cssRem
    val Medium = 4.0.cssRem
    val Large = 4.8.cssRem
    val ExtraLarge = 5.6.cssRem
    val Huge = 6.4.cssRem
    val ExtraHuge = 7.2.cssRem

    val FontScale = 62.5.percent
    val BorderRadius = ExtraTiny
    val DefaultMainPadding = 6.cssRem
    val LargeMainPadding = 5.cssRem
    val MediumMainPadding = 4.cssRem
    val SmallMainPadding = 3.cssRem
    val DefaultMainGap = 24.vh
    val LargeMainGap = 21.vh
    val MediumMainGap = 18.vh
    val SmallMainGap = 15.vh
    val TransitionDuration = 250.ms
    val TextDecorationThickness = 0.25.cssRem
    val FilledButtonHoverBrightness = 75.percent
    val OutlinedButtonBorderWidth = 2.px
    val TextUnderlineOffset = 0.5.cssRem
    val SectionNameVerticalMargin = Large
    val ItemGap = Medium
    val SmallItemGap = Small
    val CardPadding = Small
    val SmallCardPadding = ExtraSmall
    val IconSize = 1.em
    val MinIconButtonSize = IconSize * 2

}